import { Amount, Percent } from '@df/common';
import { z } from 'zod';

const amountSchema = Amount.schema;

const percentSchema = z.string().transform((str, ctx): Percent => {
  const result = Percent.fromString(str);
  if (isNaN(Percent.fraction(result))) {
    ctx.addIssue({ code: 'custom', message: `Invalid Percent string: ${str}` });
    return z.NEVER;
  } else {
    return result;
  }
});

const rangeSchema = (dataSchema: typeof amountSchema) =>
  z.object({
    start: dataSchema,
    end: dataSchema,
  });

export { rangeSchema, amountSchema, percentSchema };
